module.exports = __webpack_public_path__ + "img/PL00113.480dd8bb.svg";